import React from "react";
import DealCard from "./DealCard";
import Lottie from "lottie-react";
import { DealCardShimmer } from "../../../components/ShimmerEffect";

// ─── Lottie animation data (arrow bounce) ─────────────────────────────────────
const arrowLottie = {
  v: "5.7.4", fr: 30, ip: 0, op: 60, w: 48, h: 48,
  nm: "Arrow", ddd: 0, assets: [],
  layers: [{
    ddd: 0, ind: 1, ty: 4, nm: "arrow",
    ks: {
      o: { a: 0, k: 100 },
      r: { a: 0, k: 0 },
      p: {
        a: 1,
        k: [
          { t: 0,  s: [24, 28, 0], e: [24, 20, 0], i: { x: [0.5], y: [1] }, o: { x: [0.5], y: [0] } },
          { t: 15, s: [24, 20, 0], e: [24, 28, 0], i: { x: [0.5], y: [1] }, o: { x: [0.5], y: [0] } },
          { t: 30, s: [24, 28, 0], e: [24, 20, 0], i: { x: [0.5], y: [1] }, o: { x: [0.5], y: [0] } },
          { t: 45, s: [24, 20, 0], e: [24, 28, 0], i: { x: [0.5], y: [1] }, o: { x: [0.5], y: [0] } },
          { t: 60, s: [24, 28, 0] }
        ]
      },
      a: { a: 0, k: [0, 0, 0] },
      s: { a: 0, k: [100, 100, 100] }
    },
    shapes: [{
      ty: "gr",
      it: [
        {
          ty: "sh",
          ks: {
            a: 0,
            k: {
              i: [[0,0],[0,0],[0,0],[0,0],[0,0]],
              o: [[0,0],[0,0],[0,0],[0,0],[0,0]],
              v: [[-7,3],[0,-4],[7,3],[0,-4],[0,6]],
              c: false
            }
          }
        },
        { ty: "st", c: { a: 0, k: [0.145, 0.392, 0.965, 1] }, o: { a: 0, k: 100 }, w: { a: 0, k: 2.5 }, lc: 2, lj: 2 },
        { ty: "tr", p: { a: 0, k: [0,0] }, a: { a: 0, k: [0,0] }, s: { a: 0, k: [100,100] }, r: { a: 0, k: 0 }, o: { a: 0, k: 100 } }
      ]
    }],
    ip: 0, op: 60, st: 0, bm: 0
  }]
};

const BestDeals = ({ bestDealsLoading, bestDeals, isVisible, navigate }) => {
  if (!bestDealsLoading && (!isVisible || bestDeals.length === 0)) return null;

  return (
    <section className="pt-4 pb-8 sm:pt-5 sm:pb-10 relative overflow-hidden bg-white dark:bg-black">
      <div className="container mx-auto px-3 sm:px-4 relative z-10">
        {/* Section heading */}
        <div className="text-center mb-5 sm:mb-7">
          <h2 className="text-xl sm:text-2xl font-extrabold text-black dark:text-white mb-2 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 leading-snug">
            <span>Best Deals on a</span>{" "}
            <span className="text-blue-600 dark:text-blue-500">
              Budget
            </span>
            <div className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center flex-shrink-0">
              <Lottie animationData={arrowLottie} loop={true} />
            </div>
          </h2>
          <p className="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 px-2">Click a price range to instantly browse matching laptops</p>
        </div>

        {/* ── 4-Card Dynamic Grid ── */}
        {bestDealsLoading ? (
          <DealCardShimmer />
        ) : bestDeals.length === 0 ? (
          <p className="text-center text-gray-400 dark:text-gray-500 py-12 text-sm">No deals configured yet. Add deals from the admin panel.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
            {bestDeals.map((deal, idx) => (
              <DealCard key={deal._id || idx} deal={deal} navigate={navigate} idx={idx} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default BestDeals;
